import * as React from "react";

import { hashCode } from "../../Common";

import { useMyBagPresentationModel } from "../providers";

export const FragmentSummaryByTheNumbers: React.FunctionComponent = () => {
  const { presentationMyBagOrder } = useMyBagPresentationModel();

  const itemValuesAndDiscounts = React.useMemo(() => {
    return (
      <React.Fragment>
        <div className="orderValueByItemsBreakdown">
          <div className="orderTotal_withoutDiscountsOrAnything">
            <p className="description">{`Order Value`}</p>
            <ThePrice
              value={
                presentationMyBagOrder?.orderValueByItemsBreakdown
                  .orderTotal_withoutDiscountsOrAnything
              }
            />
          </div>
          {!!presentationMyBagOrder?.orderValueByItemsBreakdown
            .saleDiscountsAppliedOnTheOrderTotal && (
            <p className="saleDiscountsAppliedOnTheOrderTotal">
              <p className="description">{`Sale Discount`}</p>
              <ThePrice
                value={
                  presentationMyBagOrder?.orderValueByItemsBreakdown
                    .saleDiscountsAppliedOnTheOrderTotal
                }
                negative
              />
            </p>
          )}
          {!!presentationMyBagOrder?.orderValueByItemsBreakdown
            .memberDiscountsAppliedOnTheOrderTotal && (
            <p className="memberDiscountsAppliedOnTheOrderTotal">
              <p className="description">{`Rewards Member Discount`}</p>
              <ThePrice
                value={
                  presentationMyBagOrder?.orderValueByItemsBreakdown
                    .memberDiscountsAppliedOnTheOrderTotal
                }
                negative
              />
            </p>
          )}
          {!!(
            (presentationMyBagOrder?.orderValueByItemsBreakdown
              .allThePromotionalDiscounts.length || 0) > 0
          ) && (
            <div className="allThePromotionalDiscounts">
              <ul>
                {presentationMyBagOrder?.orderValueByItemsBreakdown.allThePromotionalDiscounts.map(
                  (thisDiscount) => {
                    return (
                      <li key={`${hashCode(thisDiscount.presentableLabel)}`}>
                        <p className="description">
                          <span>{thisDiscount.presentableLabel}</span>
                        </p>
                        {thisDiscount.value !== undefined &&
                        thisDiscount.value !== null ? (
                          <ThePrice value={thisDiscount.value} negative />
                        ) : null}
                      </li>
                    );
                  }
                )}
              </ul>
            </div>
          )}
        </div>
      </React.Fragment>
    );
  }, [presentationMyBagOrder]);

  const shipping = React.useMemo(() => {
    if (
      !presentationMyBagOrder?.shippingValueBreakdown ||
      presentationMyBagOrder.isThisAVirtualOrder
    ) {
      return null;
    }
    const isFreeShipping =
      presentationMyBagOrder?.shippingValueBreakdown.isFreeShipping;
    return (
      <React.Fragment>
        <div
          className={`shippingValueBreakdown ${
            isFreeShipping ? "free-shipping" : "standard-shipping"
          }`}
        >
          <p className="description">
            {isFreeShipping ? `Free Shipping` : `Standard Shipping`}
          </p>
          <ThePrice
            value={presentationMyBagOrder?.shippingValueBreakdown.shippingTotal}
          />
        </div>
      </React.Fragment>
    );
  }, [presentationMyBagOrder]);

  const giftCards = React.useMemo(() => {
    if (!presentationMyBagOrder?.giftCardValueBreakdown) {
      return null;
    }
    return (
      <React.Fragment>
        {presentationMyBagOrder.giftCardValueBreakdown?.map((giftCard, index) => (
          <div className="giftCardValueBreakdown" key={giftCard.privateBackendCode || index}>
            <p className="description">
              {`Gift Card ${giftCard.presentableCode}`}
            </p>
            <ThePrice
              value={giftCard.appliedValue}
              negative
            />
          </div>
        ))}
      </React.Fragment>
    );
  }, [presentationMyBagOrder]);

  const total = React.useMemo(() => {
    return (
      <React.Fragment>
        <div className="totalValueBreakdown">
          <div className="total-inc-gst">
            <p className="description">
              <span className="total-">{`Total `}</span>
              <span className="inc-gst-brackets">{`(inc. GST)`}</span>
            </p>
            <ThePrice
              value={presentationMyBagOrder?.totalValueBreakdown.value}
            />
          </div>
          <div className="gst">
            <p className="description">{`GST Included`}</p>
            <ThePrice value={presentationMyBagOrder?.totalValueBreakdown.gst} />
          </div>
        </div>
      </React.Fragment>
    );
  }, [presentationMyBagOrder]);

  return (
    <div className="by-the-numbers">
      {itemValuesAndDiscounts}

      {shipping}

      {giftCards}

      {total}
    </div>
  );
};

interface ThePriceProps {
  value?: number;
  negative?: boolean;
}
const ThePrice: React.FunctionComponent<ThePriceProps> = (props) => {
  return (
    <React.Fragment>
      <p
        className={`the-price ${
          props.negative ? "subtract-price" : "add-price"
        }`}
      >
        {props.negative && <span className="minus-symbol">{`-`}&nbsp;</span>}
        <span className="dollar-sign">{`\$`}</span>
        <span className="value">{`${(props.value || 0).toFixed(2)}`}</span>
      </p>
    </React.Fragment>
  );
};
